import { cn } from "@/components/libs/cn";
import { Button } from "@/components/ui/button";
import { useCommonTranslation } from "@/features/i18n/libs/useCommonTranslation";

export function StartButton({
  variant = "default",
  className,
}: {
  variant?: "default" | "header";
  className?: string;
}) {
  const { t } = useCommonTranslation();

  return (
    <Button
      to={"/test"}
      variant="hero"
      size="hero"
      rounded="full"
      className={cn("px-16 py-4 text-lg font-semibold", className)}
    >
      <span className={cn(variant === "default" && "lg:hidden")}>
        {t("common:start")}
      </span>
      {variant === "default" && (
        <span className="hidden lg:inline">{t("landing:start_diagnosis")}</span>
      )}
    </Button>
  );
}
